




































import {Component, Vue, Watch} from 'vue-property-decorator';
import mainMenu from '@/components/Menu';
import 'jstree'
import 'jstree/dist/themes/default/style.min.css';
import dataProxy from '@/services/data-proxy.service';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {TransakcijeKorisnika} from "@/services/BackendProxies";

declare const $: any;
$.jstree.defaults.checkbox.keep_selected_style = false;

@Component
export default class KorisnickeTransakcijeComponent extends mixins(ComponentBaseMixin) {
    menu = mainMenu;
    $jsTree;
    jsTree;
    zaposleni: number = 0;
    isBusy = false;

    mounted() {
        this.$jsTree = $(<any>this.$refs['menu']);
    }

    @Watch('zaposleni')
    async onZaposleniChanged(newValue) {
        if (this.jsTree) {
            this.$jsTree.jstree('destroy');
        }
        const data = await this.getData();
        this.jsTree = this.$jsTree.jstree({
            core: {
                data
            },
            "plugins": ["checkbox"]
        });

        this.$jsTree.jstree('hide_icons');
    }

    sacuvaj() {
        if (this.isBusy) return;
        if (this.zaposleni) {
            this.isBusy = true;
            try {
                const selected = this.$jsTree.jstree('get_selected', true).filter(x => x.id).map(x => x.id);
                console.log(selected);
                const transakcijeKorisnika = TransakcijeKorisnika.fromJS({idOsobe: this.zaposleni, transakcije: selected});
                this.saveData(() => dataProxy.sacuvajTransakcijeKorisnika(transakcijeKorisnika))();
            } finally {
                this.isBusy = false;
            }
        }
    }

    destroyed() {
        if (this.jsTree) {
            this.$jsTree.jstree('destroy');
        }
    }

    private async getData() {
        let transakcije = [];
        if (this.zaposleni) {
            const transakcijeKorisnika = await this.loadData(() => dataProxy.vratiTransakcijeKorisika(this.zaposleni))();
            transakcije = transakcijeKorisnika.transakcije;
        }

        const data = this.menu.map(l0 => (
            {
                id: l0.name,
                text: `<i class="${l0.icon}"></i> ${this.$i18n.t(l0.title)}`,
                state: {opened: true, selected: transakcije.indexOf(l0.name) > -1},
                children: l0.children ? (<any>l0.children).map(l1 => ({
                    id: l1.name,
                    text: this.$i18n.t(l1.title),
                    state: {opened: true, selected: transakcije.indexOf(l1.name) > -1},
                    children: l1.children ? l1.children.map(l2 => ({
                        id: l2.name,
                        text: this.$i18n.t(l2.title),
                        state: {opened: true, selected: transakcije.indexOf(l2.name) > -1},
                    })) : []
                })) : []
            }));
        return data;
    }
}
